/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="container user-avatar">
      <h1>quiz on triangles</h1>
    </header>
  );
}
export default Header;
